import { gender } from "keys"

const constants = {
    welcome: (g) => "שלום"
}

export default constants